// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UMje","colBig":"styles_colBig__1E88_","colSmall":"styles_colSmall__2YJZo"};